import {
  getVideoCategoryList,
  postVideoCategory,
  updateVideoCategory,
  deleteVideoCategory,
} from "@/services/video-category.service";
import { setPaginationDetails } from "../../utils/utils";

// initial state
const state = () => ({
  videoCategoryModel: {},
});

// mutations
const mutations = {
  setVideoCategoryModel(state, data) {
    state.videoCategoryModel = data;
  },
};

// actions
const actions = {
  //Etkinlik Listesi
  async loadVideoCategoryList(vuexContext, co) {
    return await getVideoCategoryList(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;

      items.map((item, index) => {
        item.index = index + 1;
        item.Name = item.name;
      });

      setPaginationDetails(co, totalCount, totalPages);

      return items;
    });
  },

  async postVideoCategory(vuexContext, data) {
    return await postVideoCategory(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async updateVideoCategory(vuexContext, data) {
    return await updateVideoCategory(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async deleteVideoCategory(vuexContext, data) {
    return await deleteVideoCategory(data).then((response) => {
      let data = response;
      return data;
    });
  },

  addVideoCategoryModel(vuexContext, data) {
    vuexContext.commit("setVideoCategoryModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
